import{
Component}
from"@theme/component";
import*as runtime from"./cosautil-cinturilla-app-6987c5edf15852ea.js";
export class CosaUtilCinturilla extends Component{
connectedCallback(){
super.connectedCallback?.(),this.epoch=(this.epoch||0)+1,this.scheduleInitialize()}
updatedCallback(){
super.updatedCallback?.(),this.scheduleInitialize()}
disconnectedCallback(){
this.epoch=(this.epoch||0)+1,this.pending=!1,this.release(),super.disconnectedCallback?.()}
scheduleInitialize(){
if(this.pending)return;
this.pending=!0;
const epoch=this.epoch;
queueMicrotask(()=>{
epoch===this.epoch&&(this.pending=!1,this.isConnected&&this.initialize())}
)}
release(){
const root=this.root;
root?.querySelectorAll("[data-cinturilla-native-purchase]").forEach(node=>{
node.inert=!0,node.dataset.cinturillaGuard="pending"}
),this.qaAbort?.abort(),this.qaAbort=null;
for(const controller of new Set([this.controller,root?.cinturillaController]))controller?.destroy?.();
this.controller=null,root&&(root.cinturillaController=null,root.dispatchEvent(new CustomEvent("cu:cinturilla:unmount",{
bubbles:!0}
))),this.root=null}
initialize(){
this.release();
const roots=[...this.querySelectorAll("[data-cinturilla-root]")],profiles=[...this.querySelectorAll("[data-cinturilla-profile]")],fail=()=>roots.forEach(root=>{
root.dataset.runtimeReady="false",root.querySelectorAll("[data-open-cod],[data-pack],[data-color-choice]").forEach(node=>{
node.disabled=!0,node.setAttribute("aria-disabled","true")}
),root.querySelectorAll("[data-native-status]").forEach(node=>node.textContent="La compra de este producto todav\xEDa no est\xE1 disponible.")}
);
if(roots.length!==1||profiles.length!==1||roots[0].dataset.mode!=="native"){
fail();
return}
this.root=roots[0];
try{
const profile=JSON.parse(profiles[0].textContent),native=profile.nativeProfile;
if(!profile.assets||!native)throw Error("Missing native profile");
if(native.editorQa){
if(native.consumerEnabled!==!1)throw Error("QA cannot enable consumers");
this.qaAbort=new AbortController;
const signal=this.qaAbort.signal,reject=event=>{
event.preventDefault(),event.stopImmediatePropagation(),event.target?.closest?.("form")?.reportValidity?.(),this.root?.querySelectorAll("[data-native-status]").forEach(node=>node.textContent="SOLO REVISI\xD3N \xB7 El env\xEDo de pedidos est\xE1 bloqueado.")}
;
document.addEventListener("submit",reject,{
capture:!0,signal}
),document.addEventListener("click",event=>{
const control=event.target?.closest?.('button,input,[role="button"],a[href]');
if(!control)return;
const type=(control.getAttribute("type")||(control.tagName==="BUTTON"?"submit":"")).toLowerCase(),modal=control.closest(native.nativeContractObserved?.modalSelector||"#_rsi-cod-form-modal");
(type==="submit"||type==="image"||!native.runtimeMountAllowed&&modal&&!/close/i.test(control.id||""))&&reject(event)}
,{
capture:!0,signal}
),document.addEventListener("keydown",event=>{
if(native.runtimeMountAllowed||!["Enter"," ","Spacebar"].includes(event.key)||!event.target?.closest?.(native.nativeContractObserved?.modalSelector||"#_rsi-cod-form-modal"))return;
const action=event.target.closest?.('button,[role="button"],a[href],input[type="button"],input[type="submit"],input[type="image"]');
(event.key==="Enter"||action)&&reject(event)}
,{
capture:!0,signal}
)}
if(!native.runtimeMountAllowed){
if(!native.editorQa||!native.nativeAppDiagnosticAllowed)throw Error("Native runtime is not permitted");
fail(),this.root.querySelectorAll("[data-cinturilla-native-purchase]").forEach(node=>{
node.inert=!1,node.dataset.cinturillaGuard="diagnostic"}
),this.root.querySelectorAll("[data-native-status]").forEach(node=>node.textContent="SOLO REVISI\xD3N \xB7 Diagn\xF3stico del formulario real. Conexi\xF3n del producto pendiente; pedidos bloqueados."),this.controller={
destroy(){
}
}
;
return}
if(typeof runtime.mountNative!="function")throw Error("Native adapter is missing");
if(this.controller=runtime.mountNative(this.root,profile),!this.controller||typeof this.controller.destroy!="function"||typeof this.controller.then=="function")throw Error("mountNative must return a synchronous cleanup controller")}
catch{
this.release(),fail()}
}
}
customElements.get("cosautil-cinturilla")||customElements.define("cosautil-cinturilla",CosaUtilCinturilla);


